import algoliasearch from 'algoliasearch';
import { createNullCache } from '@algolia/cache-common';
import { createInMemoryCache } from '@algolia/cache-in-memory';

export const algoliaMixin = {
  data () {
    return {
      algoliaClient: algoliasearch(
        process.env.VUE_APP_ALGOLIA_APPLICATION_ID,
        process.env.VUE_APP_ALGOLIA_SEARCH_API_KEY,
        {
          // Caches responses from Algolia
          responsesCache: createNullCache(),

          // Caches Promises with the same request payload
          requestsCache: createInMemoryCache({ serializable: false })
        }
      ),
      algoliaIndex: process.env.VUE_APP_ALGOLIA_NAMESPACE
    };
  }
};
